module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A PERMUTED PRESS BOOK")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN: 978-1-68261-702-1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ISBN (eBook): 978-1-68261-895-0")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Midnight Sun")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("© 2019 by Basil Sands")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All Rights Reserved")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cover art by Christian Bentulan")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is a work of fiction. People, places, events, and situations are the product of the author’s imagination. Any resemblance to actual persons, living or dead, or historical events, is "), _c('span', {
    staticClass: "no-break"
  }, [_vm._v("purely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means without the written permission of the author "), _c('span', {
    staticClass: "no-break"
  }, [_vm._v("and publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "",
      "src": "Images/pp_v_dark1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Permuted Press, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("New York • Nashville")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("permutedpress.com")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Published in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9858b716","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0044.vue
// module id = 69
// module chunks = 0